export enum TransmissionMean {
	OpticalFiber = '100000000',
	Wireless = '100000001',
	Copper = '100000002',
}
